<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" fixed clipped app style="border: none !important">
      <v-list v-if="menus" dense style="margin: 15px">
        <template v-for="(menu, i) in menus">
          <v-list-tile
           class="grey--text"
           active-class="blue--text" 
           :key="i" 
           :to="menu.menuLink">
            <v-list-tile-action>
              <v-icon>{{ menu.menuIcon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ menu.menuName }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>


    
    

    <v-toolbar flat style="background-color:#ffffff" app fixed clipped-left> <!-- background-image: linear-gradient(-90deg, #880e4f, #4a148c) -->
      <!-- <v-toolbar-side-icon @click="drawer = !drawer" dark></v-toolbar-side-icon> -->

      <!-- <span class="title ml-3 mr-5 white--text">
        AIMRO INDIA
      </span> -->
      <img class="logo" src="../assets/logo.png" @click="drawer = !drawer" style="cursor:pointer;max-width: 100%;max-height: 100%;"/>
      <v-spacer></v-spacer>
      <v-menu
        v-if="loggedInUserName"
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="50"
        transition="fade-transition"
        bottom
      >
        <template v-slot:activator="{ on }">
          <v-btn class="blue--text" flat v-on="on" v-if="loggedInUserName != null">
            {{loggedInUserName}}
            <v-icon color="blue" right>arrow_drop_down</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <avatar :size="40" :username="loggedInUserName"></avatar>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{loggedInUserName}}</v-list-tile-title>
                <v-list-tile-sub-title>{{roleType}}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <v-divider></v-divider>

          <v-list>

            <v-list-tile @click="home()">
              <v-list-tile-action>
                <v-icon>home</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Home</v-list-tile-title>
            </v-list-tile>

            <v-list-tile @click="changePassword()">
              <v-list-tile-action>
                <v-icon>vpn_key</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Change password</v-list-tile-title>
            </v-list-tile>

            <v-list-tile @click="logOutDialog = true">
              <v-list-tile-action>
                <v-icon>power_settings_new</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Log out</v-list-tile-title>

              <v-dialog v-model="logOutDialog" max-width="290">
                <v-card style="padding: 20px !important ; border-radius: 10px">
                  <h4 style="text-align:center;font-size:20px">Logout</h4>

                  <v-card-text style="text-align:center">Are you sure you want to logout from Bishnu tours and travels ?</v-card-text>

                  
                    <v-btn style="padding-left:60px" dark color="green" flat @click="logOutDialog = false">No</v-btn>
                    <v-btn dark color="red" flat @click="logOut()">Yes</v-btn>
                </v-card>
              </v-dialog>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-content>
      <transition :name="transitionName" mode="out-in" @beforeLeave="beforeLeave" @enter="enter">
        <router-view></router-view>
      </transition>
    </v-content>
  </v-app>
</template>

<script>
import Avatar from "vue-avatar";
const DEFAULT_TRANSITION = "fade";

export default {
  components: {
    Avatar
  },
  data: () => ({
    menu: false,
    drawer: null,
    fav: true,
    prevHeight: 0,
    transitionName: DEFAULT_TRANSITION,
    menus: null,
    logOutDialog: false,
    roleType: sessionStorage.roles,
    loggedInUserName: sessionStorage.loggedInUserName,
    loggedInUserID: sessionStorage.loggedInUserID,
    theme: sessionStorage.theme,
    src: "https://aimroindia.com/aimro/api/ProfilePic/" + sessionStorage.loggedInUserID,
    notification: {
      count: 1,
      show: true
    }
  }),
  props: {
    source: String
  },

  methods: {
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      this.prevHeight = getComputedStyle(element).height;
    },

    
      getData() {
      this.axios
        .get(config.API + "Admin/" + sessionStorage.loggedInUserID, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.form = res.data;
          this.$Progress.finish();
          this.getData();
        });
    },

    home() {
      this.$router.push(`/main`);
      window.location.reload();
    },

    changePassword() {
      this.$router.push(`changePassword/${this.loggedInUserID}`);
    },
    logOut() {
      // this.$router.push("/login");
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/main");
      });
    },

    user() {
      this.$router.push(`/user`);
    },
    dash() {
      this.$router.push(`/_`);
    },
    hotel() {
      this.$router.push(`/hotel`);
    },
    setup() {
      this.$router.push(`/setup`);
    },
    room() {
      this.$router.push(`/rooms`);
    },
    book() {
      this.$router.push(`/bookingStatusHotelier`);
    },
    cancel() {
      this.$router.push(`/cancellationHotelier`);
    },
    refund() {
      this.$router.push(`/refundHotelier`);
    }
  },

  created() {
    this.menus = Object.values(
      JSON.parse(sessionStorage.getItem("menus") || "[]")
    ).map(function(menu) {
      return menu;
    });

    this.$router.beforeEach((to, from, next) => {
      let transitionName = to.meta.transitionName || from.meta.transitionName;
      if (transitionName === "slide") {
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        transitionName = toDepth < fromDepth ? "slide-right" : "slide-left";
      }
      this.transitionName = transitionName || DEFAULT_TRANSITION;
      next();
    });

    this.getData();

    
  }
};
</script>

<style>
.menulist {
  font-family: "Google Sans Bold" !important;
  color: grey;
}
hr {
  border: #fff;
}
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}

@media screen and (max-width: 768px) {

  .logo {
  height: 30px;
  max-width: 100%;
  max-height: 100%;
}

}
</style>
